// @flow
import { createAction } from 'redux-actions';

export const getCategories = createAction('GET_CATEGORIES');
export const getCategoriesSuccess = createAction('GET_CATEGORIES_SUCCESS');
export const getCategoriesFailure = createAction('GET_CATEGORIES_FAILURE');

export const createCategory = createAction('CREATE_CATEGORY',(payload) => payload, (payload, metadata) => metadata);
export const createCategorySuccess = createAction('CREATE_CATEGORY_SUCCESS',(payload) => payload, (payload, metadata) => metadata);
export const createCategoryFailure = createAction('CREATE_CATEGORY_FAILURE');

export const updateCategory = createAction('UPDATE_CATEGORY', (payload) => payload, (payload, metadata) => metadata);
export const updateCategorySuccess = createAction('UPDATE_CATEGORY_SUCCESS');
export const updateCategoryFailure = createAction('UPDATE_CATEGORY_FAILURE');

export const updateCategories = createAction('UPDATE_CATEGORIES');
export const updateCategoriesSuccess = createAction('UPDATE_CATEGORIES_SUCCESS');
export const updateCategoriesFailure = createAction('UPDATE_CATEGORIES_FAILURE');

export const deleteCategory = createAction('DELETE_CATEGORY', (payload) => payload, (payload, metadata) => metadata);
export const deleteCategorySuccess = createAction('DELETE_CATEGORY_SUCCESS');
export const deleteCategoryFailure = createAction('DELETE_CATEGORY_FAILURE');

